// src/vocabulary/C1/unit4/questions.js

const questions = [
  // 🟢 Meaning & understanding
  {
    id: 1,
    type: "choice",
    question: "What does 'bias' mean in media?",
    options: [
      "Complete truth",
      "Neutral information",
      "Unfair preference or influence"
    ],
    correctAnswer: "Unfair preference or influence"
  },

  {
    id: 2,
    type: "choice",
    question: "Which word refers to false or misleading information?",
    options: [
      "Source",
      "Objective",
      "Misinformation"
    ],
    correctAnswer: "Misinformation"
  },

  // 🟡 Usage & nuance
  {
    id: 3,
    type: "choice",
    question: "Choose the most accurate sentence:",
    options: [
      "People should question the source of information.",
      "People should question information source the.",
      "People question should information."
    ],
    correctAnswer: "People should question the source of information."
  },

  {
    id: 4,
    type: "choice",
    question: "Which sentence shows critical thinking?",
    options: [
      "I believe everything online.",
      "I compare different news sources.",
      "I share news without reading it."
    ],
    correctAnswer: "I compare different news sources."
  },

  // 🔵 Critical thinking
  {
    id: 5,
    type: "choice",
    question: "Why is media manipulation dangerous?",
    options: [
      "Because it saves time",
      "Because it can shape opinions unfairly",
      "Because it increases objectivity"
    ],
    correctAnswer: "Because it can shape opinions unfairly"
  },

  {
    id: 6,
    type: "choice",
    question: "Which sentence best reflects a C1-level idea?",
    options: [
      "News is important.",
      "Media affects people.",
      "Media literacy is essential in the digital age."
    ],
    correctAnswer: "Media literacy is essential in the digital age."
  }
];

export default questions;


